export default __webpack_public_path__ + "static/media/whiteArrowDown.fe74864b.svg";